import moment from 'moment'

// Trial end date for a free trial start timestamp. Mirrors `trialEnd` in
// components/globals/Sidebar.vue, which should be migrated to use this.
export const getTrialEndDate = (freeTrialDate) => {
  if (!freeTrialDate) return null
  return moment(freeTrialDate).add(7, 'days')
}

// Whole days left in the trial (0 once it has ended)
export const getTrialDaysLeft = (freeTrialDate) => {
  const trialEnd = getTrialEndDate(freeTrialDate)
  if (!trialEnd) return 0
  const days = moment.duration(trialEnd.diff(moment(), 'seconds'), 'seconds').days()
  return days > 0 ? days : 0
}
